module.exports = __webpack_public_path__ + "static/img/02.117336d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news22/02.png
// module id = 3gLY
// module chunks = 1